const dateTimeBR = (date, with_hour = false) => {
    if(!date || date == undefined) return "";
    let dataHora = new Date(date);

    let opcoes = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',

      timeZoneName: 'short'
    };

    if(with_hour)
        opcoes = {
            ...opcoes,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }

    let brFormat = new Intl.DateTimeFormat('pt-BR', opcoes);
    brFormat = brFormat.format(dataHora).replace(',', ' - ').replace(/([^\s]*)$/, '');

    if(!with_hour) brFormat = brFormat.replace('-','');

    brFormat = brFormat.trim();

    return brFormat;
}

function pad(number, length) {
    let str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
}

export const dateToCustomString = (date) => {
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1, 2); // getMonth() é 0-indexado
  const day = pad(date.getDate(), 2);
  const hours = pad(date.getHours(), 2);
  const minutes = pad(date.getMinutes(), 2);
  const seconds = pad(date.getSeconds(), 2);

  // Adicionando fração de milissegundos para obter 7 dígitos
  const fractionalSeconds = pad(Math.floor(date.getMilliseconds() * 1000), 7);

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${fractionalSeconds}`;
}

export default dateTimeBR;
